import { Bar, BarChart, XAxis, YAxis, Cell } from 'recharts'
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart'

const chartData = [
  { name: 'Original JPG', size: 7689, key: 'original' },
  { name: '1920w WebP', size: 247, key: 'w1920' },
  { name: '1200w WebP', size: 129, key: 'w1200' },
  { name: '800w WebP', size: 73, key: 'w800' },
  { name: '480w WebP', size: 37, key: 'w480' },
]

const chartConfig = {
  size: {
    label: 'File Size',
  },
  original: {
    label: 'Original JPG',
    color: 'var(--chart-1)',
  },
  w1920: {
    label: '1920w WebP',
    color: 'var(--chart-2)',
  },
  w1200: {
    label: '1200w WebP',
    color: 'var(--chart-3)',
  },
  w800: {
    label: '800w WebP',
    color: 'var(--chart-4)',
  },
  w480: {
    label: '480w WebP',
    color: 'var(--chart-5)',
  },
}

function formatSize(kb) {
  if (kb >= 1000) {
    return `${(kb / 1000).toFixed(1)}MB`
  }
  return `${kb}KB`
}

// Custom bar with gradient
function GlowingBar(props) {
  const { fill, x, y, width, height, payload } = props
  const gradientId = `gradient-${payload?.key}`
  const color = chartConfig[payload?.key]?.color || 'var(--chart-1)'
  
  if (!width || !height || width <= 0 || height <= 0) return null
  
  return (
    <>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor={color} stopOpacity={0.8} />
          <stop offset="100%" stopColor={color} stopOpacity={1} />
        </linearGradient>
      </defs>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={`url(#${gradientId})`}
        rx={4}
        ry={4}
      />
    </>
  )
}

// Custom label component
function SizeLabel(props) {
  const { x, y, width, height, value } = props
  return (
    <text
      x={x + width + 8}
      y={y + height / 2}
      dy={4}
      fill="currentColor"
      fontSize={12}
      className="fill-muted-foreground"
    >
      {formatSize(value)}
    </text>
  )
}

export function PhotoSizeChart() {
  return (
    <ChartContainer config={chartConfig} className="aspect-[4/3] w-full">
      <BarChart
        data={chartData}
        layout="vertical"
        margin={{ top: 8, right: 70, bottom: 8, left: 0 }}
      >
        <XAxis type="number" hide />
        <YAxis
          dataKey="name"
          type="category"
          tickLine={false}
          axisLine={false}
          width={100}
          tick={{ fontSize: 12 }}
        />
        <Bar 
          dataKey="size" 
          shape={<GlowingBar />}
          label={<SizeLabel />}
        >
          {chartData.map((entry) => (
            <Cell key={entry.key} fill={chartConfig[entry.key]?.color} />
          ))}
        </Bar>
      </BarChart>
    </ChartContainer>
  )
}
